import React, { ReactElement, CSSProperties } from 'react';
import { Card } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

interface CarteProps {
    title: string;
    subtitle: string;
    colorsubtitle?: string;
    text: ReactElement;
    hasbutton?: boolean;
    buttonvariant?: string;
    classnamebody?: string;
    classnametitle?: string;
    classnamesubtitle?: string;
    classnametexte?: string;
    classnamebutton?: string;
    cardbackgroundcolor?: string;
    style?: CSSProperties | undefined;
}
const Carte: React.FC<CarteProps> = ({
    title,
    subtitle,
    colorsubtitle,
    text,
    hasbutton,
    buttonvariant,
    classnamebutton,
    classnamebody,
    classnametexte,
    cardbackgroundcolor,
    style,
}) => {
    return (
        <Card border="dark" style={style} bg={cardbackgroundcolor}>
            <Card.Body className={classnamebody}>
                <Card.Title className="text-center">{title}</Card.Title>
                <Card.Subtitle style={{ marginBottom: '1.25rem', color: colorsubtitle }} className="text-center">
                    {subtitle}
                </Card.Subtitle>
                {text}
            </Card.Body>
            {hasbutton && <Button variant={buttonvariant} className={classnamebutton}></Button>}
        </Card>
    );
};

export default Carte;
